<template>
    <div class="form">
        <h4 class="step-title">
            What is your date of birth?
        </h4>
        <div class="step-content d-flex flex-column align-items-center">
            <div class="step-item">
                <div class="form-group">
                    <div class="m-2">
                        <select class="form-control" v-model="lead.dateOfBirthMonth" v-on:change="onChange">
                            <option disabled value="">Month</option>
                            <option v-for="month in months" v-bind:key="month.value" v-bind:value="month.value">
                                {{ month.text }}
                            </option>
                        </select>
                    </div>
                    <div class="m-2">
                        <select class="form-control" v-model="lead.dateOfBirthDay" v-on:change="onChange">
                            <option disabled value="">Day</option>
                            <option v-for="day in days" v-bind:key="day" v-bind:value="day">
                                {{ day }}
                            </option>
                        </select>
                    </div>
                    <div class="m-2">
                        <select class="form-control" v-model="lead.dateOfBirthYear" v-on:change="onChange">
                            <option disabled value="">Year</option>
                            <option v-for="year in years" v-bind:key="year" v-bind:value="year">
                                {{ year }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="step-item" v-if="lead.dateOfBirthMonth && lead.dateOfBirthDay && lead.dateOfBirthYear">
                <button class="btn step-btn" ref="complete" v-on:click="completeIfDone">Continue</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DateOfBirth",
        data: function() {
            return {
                days: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
                months: [
                    { text: "January", value: 1 },
                    { text: "February", value: 2 },
                    { text: "March", value: 3 },
                    { text: "April", value: 4 },
                    { text: "May", value: 5 },
                    { text: "June", value: 6 },
                    { text: "July", value: 7 },
                    { text: "August", value: 8 },
                    { text: "September", value: 9 },
                    { text: "October", value: 10 },
                    { text: "November", value: 11 },
                    { text: "December", value: 12 },
                ],
                daysByMonth: {
                    1: 31,
                    2: 28,
                    3: 31,
                    4: 30,
                    5: 31,
                    6: 30,
                    7: 31,
                    8: 31,
                    9: 30,
                    10: 31,
                    11: 30,
                    12: 31
                }
            }
        },
        created: function() {
            if (!this.lead.dateOfBirthDay) {
                this.lead.dateOfBirthDay = "";
            }
            if (!this.lead.dateOfBirthMonth) {
                this.lead.dateOfBirthMonth = "";
            }
            if (!this.lead.dateOfBirthYear) {
                this.lead.dateOfBirthYear = "";
            }
        },
        props: {
            lead: Object
        },
        methods: {
            onChange: function() {
                this.updateDays();

                // reset day if no longer valid
                if (this.lead.dateOfBirthDay) {
                    this.utils.log("here");
                    this.utils.log(this.days);
                    if (this.days.indexOf(this.lead.dateOfBirthDay) < 0) {
                        this.lead.dateOfBirthDay = "";
                    }
                }

                this.completeIfDone();
            },
            completeIfDone: function() {
                this.utils.log(this.lead.dateOfBirthYear + "-" + this.lead.dateOfBirthMonth + "-" + this.lead.dateOfBirthDay);
                if (this.lead.dateOfBirthDay && this.lead.dateOfBirthMonth && this.lead.dateOfBirthYear) {
                    this.$emit("complete", this.$options.name, this.lead.dateOfBirthYear + "-" + this.lead.dateOfBirthMonth + "-" + this.lead.dateOfBirthDay);
                }
            },
            updateDays: function() {
                if (!this.lead.dateOfBirthMonth) {
                    return;
                }

                var daysInMonth = this.getDaysInMonth();
                var day = this.days[this.days.length - 1];

                // add additional days
                while (day < daysInMonth) {
                    day++;
                    this.days.push(day);
                }

                // remove extra days
                while (day > daysInMonth + 1) {
                    day = this.days.pop();
                }
            },
            getDaysInMonth: function() {
                var daysInMonth = this.daysByMonth[this.lead.dateOfBirthMonth];

                if (this.lead.dateOfBirthMonth == 2 && this.lead.dateOfBirthYear && this.lead.dateOfBirthYear % 4 == 0) {
                    daysInMonth = 29;
                }

                return daysInMonth;
            }
        },
        computed: {
            years: function() {
                var years = [];
                var year = new Date().getFullYear() - 16;

                while(years.length < 84) {
                    years.push(year);
                    year--;
                }

                return years;
            }
        }
    }
</script>
